import React from 'react'
import { useNavigate } from 'react-router-dom'

const PhotoStoryLanding = () => {
  const navigate = useNavigate()

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh',
      fontFamily: 'system-ui, sans-serif',
      color: '#2a2a2a',
      background: 'linear-gradient(135deg, #C05621 0%, #9C4221 100%)'
    }}>
      {/* Header */}
      <header style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 2rem',
        color: 'white'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back to Home
        </button>
      </header>

      {/* Hero Section */}
      <section style={{
        textAlign: 'center',
        padding: '4rem 2rem',
        color: 'white'
      }}>
        <div style={{
          marginBottom: '1rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img 
            src="/photo-story/logo.png" 
            alt="Logo" 
            style={{
              height: '100px',
              width: 'auto',
              borderRadius: '16px'
            }}
          />
        </div>
        <h1 style={{
          fontSize: window.innerWidth <= 768 ? '2.5rem' : '3.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
          margin: '0 0 1rem 0'
        }}>
          Photo Story
        </h1>
        <p style={{
          fontSize: '1.2rem',
          marginBottom: '2rem',
          opacity: 0.9,
          maxWidth: '600px',
          margin: '0 auto 2rem auto'
        }}>
          Organize your photos and memories the way you want to see them
        </p>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            backgroundColor: 'white',
            color: '#C05621',
            textDecoration: 'none',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
            opacity: 0.9
          }}
        >
          <svg width="20" height="24" viewBox="0 0 20 24" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.02 15.25 3.24 7.59 9.03 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.15c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          Coming soon to the Apple App Store
        </div>
      </section>

      {/* Coming Soon Section */}
      <section style={{
        padding: '4rem 2rem',
        backgroundColor: 'white',
        color: '#2a2a2a',
        textAlign: 'center'
      }}>
        <h2 style={{
          fontSize: '2.5rem',
          marginBottom: '2rem',
          color: '#C05621'
        }}>
          Coming Soon
        </h2>
        <p style={{
          fontSize: '1.2rem',
          lineHeight: '1.8',
          maxWidth: '600px',
          margin: '0 auto',
          color: '#666'
        }}>
          We're working hard to bring you an amazing photo storytelling experience. 
          Check back soon for updates!
        </p>
      </section>

      {/* Support Section */}
      <section style={{
        padding: '4rem 2rem',
        backgroundColor: 'white',
        color: '#2a2a2a'
      }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          marginBottom: '3rem',
          color: '#C05621'
        }}>
          Support & Contact
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div style={{
            padding: '2rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <h4 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Email Support</h4>
            <p>Get help at signalpeaksw@outlook.com</p>
          </div>
          <div 
            onClick={() => window.open('/photo-story/support.html', '_blank')}
            style={{
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <h4 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>FAQ & Support</h4>
            <p>Frequently asked questions and answers</p>
          </div>
          <div 
            onClick={() => navigate('/photo-story/help')}
            style={{
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <h4 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Documentation</h4>
            <p>Comprehensive guides and tutorials</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '2rem',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '2rem',
          marginBottom: '1rem',
          flexWrap: 'wrap'
        }}>
          <a href="/photo-story/privacy.html" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Privacy Policy
          </a>
          <a href="/photo-story/terms.html" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Terms of Service
          </a>
          <a href="/photo-story/support.html" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Support & FAQ
          </a>
          <a href="mailto:signalpeaksw@outlook.com" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Contact
          </a>
        </div>
        <p style={{ opacity: 0.7, fontSize: '0.9rem' }}>
          &copy; {new Date().getFullYear()} Signal Peak Software. All rights reserved.
        </p>
      </footer>
    </div>
  )
}

export default PhotoStoryLanding

